import { ShowCaseGame } from './ShowcaseGame.js';
import './css/App.css';
import mircea1 from './assets/mircea1.png';
import mircea2 from './assets/mircea2.png';
import mircea3 from './assets/mircea3.png';
import mircea4 from './assets/mircea4.png';
import mircea5 from './assets/mircea5.png';

function MirceaView() {

  const description = "Mircea is a short spooky adventure game. Explore a subway infested by mysterious, bug-like beings. Investigate and understand the monsters to capture them... before they capture you.";
  var displayImages = [mircea1, mircea2, mircea3, mircea4, mircea5];

  return (
    <div className="App" style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100vh',
      zIndex: -1
    }}>
    <div className="App">
      <ShowCaseGame 
        title1="MIRCEA"
        title2="WISHLIST ON STEAM!"
        title1Color="mircea"
        displayImages={displayImages}
        description={description}
        linkedButtonText="Wishlist on Steam"
        steamLink="https://store.steampowered.com/app/3252240/Mircea/"
      />
    </div>
    </div>
  );
}

export default MirceaView;
